import { Button, Stack, Text, Title } from "@mantine/core";
import { IconMail } from "@tabler/icons-react";
import { NavLink } from "react-router-dom";

export function CheckEmail() {
  return (
    <Stack h="100%" justify="center" align="center" pb="lg" px="xl" gap="xl">
      <IconMail size={60} stroke={1.5} />
      <Title ta="center">Check your inbox</Title>
      <Text ta="center" size="lg">
        We've sent a confirmation link to your email address. Please click the link to complete your
        registration.
      </Text>
      <Button component={NavLink} to="/" size="lg" radius="xl" variant="default">
        Back to Login
      </Button>
    </Stack>
  );
}
